module.exports = __webpack_public_path__ + "media/images/gallery/11-19fd0f841b60cf5b11c685b58ad4644d.jpg";